module.exports = __webpack_public_path__ + "static/media/mountadex-macbook-mountain-about.4a5d573f.jpg";